import { FiTaskCategoryType, FiTaskPriorityType, FiTaskStatusType } from './fi-task-v2-enums';
import { IIdTextId } from '@fi-shared/fi-shared-interfaces';
import { FiTaskReportStatusType } from './fi-task-v2-report/fi-task-v2-report-enums';
import { ProgressStatusConfigType } from '@fi-shared/fi-progress-badge/fi-progress-badge.d';

export const FiTaskStatuses: IIdTextId[] = [
    {
        id: FiTaskStatusType.NotStarted,
        textId: 'checklist.not_started',
    },
    {
        id: FiTaskStatusType.InProcess,
        textId: 'taskv2.in_progress',
    },
    {
        id: FiTaskStatusType.Completed,
        textId: 'common.completed',
    },
    {
        id: FiTaskStatusType.Cancelled,
        textId: 'common.cancelled',
    },
];

export const FiTaskReportStatuses: IIdTextId[] = [
    {
        id: FiTaskReportStatusType.Overdue,
        textId: 'task.overdue',
    },
    {
        id: FiTaskReportStatusType.NotStarted,
        textId: 'checklist.not_started',
    },
    {
        id: FiTaskReportStatusType.InProgress,
        textId: 'taskv2.in_progress',
    },
    {
        id: FiTaskReportStatusType.Completed,
        textId: 'common.completed',
    },
];

export const FiTaskPriorities: IIdTextId[] = [
    {
        id: FiTaskPriorityType.Low,
        textId: 'common.low',
    },
    {
        id: FiTaskPriorityType.Medium,
        textId: 'common.medium',
    },
    {
        id: FiTaskPriorityType.High,
        textId: 'common.high',
    },
];

export const FiTaskCategories: IIdTextId[] = [
    {
        id: FiTaskCategoryType.AssignedByMe,
        textId: 'task.assigned_by_me',
    },
    {
        id: FiTaskCategoryType.AssignedToMe,
        textId: 'task.assigned_to_me',
    },
    {
        id: FiTaskCategoryType.Private,
        textId: 'task.private_task',
    },
    {
        id: FiTaskCategoryType.AssignedToOthers,
        textId: 'task.assigned_to_others',
    },
];

export const FiTaskStatusesConfig: ProgressStatusConfigType<FiTaskStatusType> = {
    [FiTaskStatusType.NotStarted]: {
        textId: 'checklist.not_started',
        statusClass: 'fi-progress-badge--not-started',
    },
    [FiTaskStatusType.InProcess]: {
        textId: 'taskv2.in_progress',
        statusClass: 'fi-progress-badge--in-progress',
    },
    [FiTaskStatusType.Completed]: {
        textId: 'common.completed',
        statusClass: 'fi-progress-badge--completed',
    },
    [FiTaskStatusType.Cancelled]: {
        textId: 'common.cancelled',
        statusClass: 'fi-progress-badge--cancelled',
    },
};
